export default "__VITE_ASSET__BBMIQMmE__"